import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BenutzermanagementAPIService } from '../../api/benutzermanagement/benutzermanagement-api.service';

@Component({
  selector: 'san-customizable-popup',
  templateUrl: './customizable-popup.component.html',
  styleUrls: ['./customizable-popup.component.scss'],
  standalone: false,
})
export class CustomizablePopupComponent {
  @Input() ID = '';
  bestaetigen = false;
  title = '';
  content: string = '';

  constructor(
    private activeModal: NgbActiveModal,
    private bmClient: BenutzermanagementAPIService,
  ) {}

  ngOnInit(): void {
    this.getContent();
  }

  alsGelesenMarkieren() {
    this.activeModal.dismiss();
    this.bmClient.setPopupViewed(this.ID, false).subscribe();
  }

  alsWeggeklicktMarkieren() {
    if (this.bestaetigen) {
      this.alsGelesenMarkieren();
    }
    this.activeModal.dismiss();
    this.bmClient.setPopupViewed(this.ID, true).subscribe();
  }

  schliessen(bestaetigen: boolean) {
    if (bestaetigen) {
      this.alsGelesenMarkieren();
    } else {
      this.alsWeggeklicktMarkieren();
    }
  }

  getContent() {
    if (this.ID) {
      this.bmClient.getPopupContent(this.ID).subscribe((res) => {
        this.title = res.title;
        this.content =
          typeof res.content === 'string'
            ? res.content
            : 'Fehler beim anzeigen des Popups';
      });
    }
  }
}
